/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

export class XMLUtilities {
  public static SerializeToString(element: Node): string {
    const serializer = new XMLSerializer();
    return serializer.serializeToString(element);
  }

  public static ParseFromString(input: string, mimeType: DOMParserSupportedType): Document {
    return new DOMParser().parseFromString(input, mimeType);
  }
}
